<template>
  <div class="add-to-cart">
    <button
      class="secondary-gradient cta-button pulse"
      :disabled="(subscription.status === 'active' && new Date() > new Date(subscription.current_period_end)) || subscription.status === 'inactive' || subscription.status === 'validation pending'"
      type="button"
       @click="
        shipTo()
      "
    >
      SHIP TO...
    </button>
  </div>
</template>

<script>
export default {
  name: 'add-to-cart',
  props: {
    name: String,
    price: String,
    quantity: String,
    pImage: String,
    pId: String,
    subscription: Object
  },
  data() {
    return {
      item: {
        productName: this.name,
        productImage: this.pImage,
        productPrice: this.price,
        product_Id: this.pId,
        productQuantity: 1
      }
    }
  },
  methods: {
    shipTo() {
      this.$store.commit('addToCart', this.item)
      const user = JSON.parse(localStorage.getItem('user'));
      if(user && localStorage.getItem('token') && (user.role === 'user' || user.role === 'guest')) {
        this.$emit('open-modal', {type: 'shippingAddressFormModal', flow: 'shippable'})
      } else {
        this.$emit('open-modal', {type: 'loginModal', flow: 'shippable'})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-to-cart {
	margin: 0 30px 0 0px;
	padding: 0;
}
.cta-button {
	background: linear-gradient(to right, #fb7377, #c95c5f);
	margin-top: 0;
	width: 100%;
	padding: 5px;
	color: white;
	// margin-top: 5px 10px 50px 10px;
	align-items: center;
	justify-content: space-between;
	height: 52px;
	border: none;
	border-radius: 5px;
	font-size: 1.4em;
	text-align: center;
	letter-spacing: 0rem;
	text-transform: uppercase;
	font-weight: 500;
	// white-space: nowrap;
	transition: all 0.2s linear;
}

.cta-button:hover {
	transform: scale(1);
	box-shadow: none;
//   background: linear-gradient(to right, #f7921ec9, #c46428a8);
}

.cta-button:active {
	animation: pulse 0.25s infinite ease-out;
	background: linear-gradient(to right, #fb7377, #c95c5f);
}

.cta-button:focus {
	outline: 0;
}
.cta-button:disabled {
	-webkit-transform: scale(1);
	transform: scale(1);
	box-shadow: none;
}

@keyframes pulse {
	0% {
    transform: scale(0.9);
	}
	40% {
		transform: scale(1);
	}
	80% {
		transform: scale(1);
	}
	100% {
		transform: scale(0.9);
	}
}
</style>
